import { getBackgroundImageOptions } from "@circle-react-shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import type { DefaultBlockStyles } from "../Homepage/constants";

export const blogPrimaryBlockDefaultStyles: DefaultBlockStyles = {
  backgroundColor: "var(--theme-website-color-background-primary)",
  padding: {
    paddingTop: "112",
    paddingBottom: "112",
    paddingLeft: "56",
    paddingRight: "56",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
};

export const blogSecondaryBlockDefaultStyles: DefaultBlockStyles = {
  backgroundColor: "var(--theme-website-color-background-secondary)",
  padding: {
    paddingTop: "112",
    paddingBottom: "112",
    paddingLeft: "56",
    paddingRight: "56",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
};

export const blogTertiaryBlockDefaultStyles: DefaultBlockStyles = {
  backgroundColor:
    "var(--theme-website-primary-button-default-background-color)",
  padding: {
    paddingTop: "112",
    paddingBottom: "112",
    paddingLeft: "56",
    paddingRight: "56",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
};

export const getBlogBlockPrimaryStyleOptions = () => ({
  backgroundColor: getBackgroundColorOptions({
    defaultValue: blogPrimaryBlockDefaultStyles.backgroundColor,
  }),
  backgroundImage: getBackgroundImageOptions(),
  padding: getPaddingOptions({
    defaultValue: blogPrimaryBlockDefaultStyles.padding,
  }),
  margin: getMarginOptions({
    defaultValue: blogPrimaryBlockDefaultStyles.margin,
  }),
});

export const getBlogBlockSecondaryStyleOptions = () => ({
  backgroundColor: getBackgroundColorOptions({
    defaultValue: blogSecondaryBlockDefaultStyles.backgroundColor,
  }),
  backgroundImage: getBackgroundImageOptions(),
  padding: getPaddingOptions({
    defaultValue: blogSecondaryBlockDefaultStyles.padding,
  }),
  margin: getMarginOptions({
    defaultValue: blogSecondaryBlockDefaultStyles.margin,
  }),
});

export const getBlogBlockTertiaryStyleOptions = () => ({
  backgroundColor: getBackgroundColorOptions({
    defaultValue: blogTertiaryBlockDefaultStyles.backgroundColor,
  }),
  backgroundImage: getBackgroundImageOptions(),
  padding: getPaddingOptions({
    defaultValue: blogTertiaryBlockDefaultStyles.padding,
  }),
  margin: getMarginOptions({
    defaultValue: blogTertiaryBlockDefaultStyles.margin,
  }),
});
